import { useMemo } from 'react'
import { usePartnerId } from 'utils/routing/params.hooks'
import { useCurrentAccountContext } from 'utils/current-account/CurrentAccountContext'

interface InsightsPortalAuthorizationContext {
  partnerIds: string[]
  retailerIds: string[]
  retailerLocationIds: string[]
}

export const useInsightsPortalAuthorizationContext = () => {
  const account = useCurrentAccountContext()
  const urlPartnerId = usePartnerId()

  const authorizationContext = useMemo(() => {
    const authorizationContext: InsightsPortalAuthorizationContext = {
      partnerIds: [urlPartnerId],
      retailerIds: [],
      retailerLocationIds: [],
    }

    if (account?.account) {
      const internalAccessConfiguration = account.account.internalAccessConfiguration

      if (internalAccessConfiguration.hasNothingAccessible) {
        return authorizationContext
      }

      // if the user doesn't have access to all retailers, add assignedRetailers' ids to authorizationContext
      if (!internalAccessConfiguration.hasFullPartnerAccess) {
        authorizationContext.retailerIds.push(
          ...internalAccessConfiguration.assignedRetailers.map(({ id }) => id)
        )
      }

      // if the user doesn't have access to all retailer locations, add assignedRetailerLocations' ids to authorizationContext
      if (!internalAccessConfiguration.hasFullRetailerAccess) {
        authorizationContext.retailerLocationIds.push(
          ...internalAccessConfiguration.assignedRetailerLocations.map(({ id }) => id)
        )
      }
    }

    return authorizationContext
  }, [account.account, urlPartnerId])

  return authorizationContext
}
